import { http } from '@admin-base/core'

const prefix = '/'

// 音频列表 type:audio
const audioList = data => {
    return http.post(prefix + 'api/resource/video/pageList', data)
}

// 新增音频 type:audio
const addAudio = data => {
    return http.post(prefix + 'api/resource/video/add', data)
}

// 编辑音频
const editAudio = data => {
    return http.post(prefix + 'api/resource/video/edit', data)
}

// 删除音频
const deleteAudio = data => {
    return http.post(prefix + `api/resource/video/delete/${data}`)
}

// 上/下架音频
const changeStatus = data => {
    return http.post(prefix + 'api/resource/video/changeStatus', data)
}

// 音频详情
const audioDetail = data => {
    return http.get(prefix + `api/resource/video/info/${data}`)
}

// 申请列表 type:audio
const applyList = data => {
    return http.post(prefix + 'api/resource/video/apply/List', data)
}

// 拒绝列表 type:audio
const rejectList = data => {
    return http.post(prefix + 'api/resource/video/reject/List', data)
}

// 审核音频
const audioReview = data => {
    return http.post(prefix + 'api/resource/video/review', data)
}

export {
    audioList,
    addAudio,
    editAudio,
    deleteAudio,
    changeStatus,
    audioDetail,
    applyList,
    rejectList,
    audioReview,
}
